var map = {
	"./b_bpair_win.mp3": "a3b3",
	"./b_bppair_win.mp3": "857a",
	"./b_ppair_win.mp3": "ee57",
	"./banker_win.mp3": "9c91",
	"./bet_success.mp3": "256f",
	"./chip1.mp3": "67c9",
	"./chip2.mp3": "a505",
	"./di2.mp3": "e78e",
	"./dragon_win.mp3": "8851",
	"./p_bpair_win.mp3": "0a3d",
	"./p_bppair_win.mp3": "80f5",
	"./p_ppair_win.mp3": "59f7",
	"./player_win.mp3": "6d09",
	"./start_bet.mp3": "7c75",
	"./stop_bet.mp3": "9a43",
	"./t_bpair.mp3": "61e4",
	"./t_bppair.mp3": "dd06",
	"./t_ppair.mp3": "bc94",
	"./tie.mp3": "dafd",
	"./tiger_win.mp3": "ccdd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba5b";